import React from "react";
import { useTranslation } from "react-i18next";
import { PageSelectionButton } from "../PageSelectionButton/PageSelectionButton";
import { getImage } from "../../services/ImageService";

export function ResourcePageSelection(props) {
    const { t } = useTranslation();

    return (
        <div className="group h-full flex items-center items-center cursor-pointer select-none">
            <div className="bg-[#368E66] md:px-12 text-[14px] font-bold text-white hover:text-primary-accent-hovered h-full w-full flex items-center z-20">
                {t("resources")}
                <div className="w-5 pl-2 mt-1">
                    <img
                        src={getImage("menu_down_white")}
                        className="w-full"
                    />
                </div>
            </div>
            <div className="hidden group-hover:flex absolute flex-col bg-[#3A9E70] z-10 w-max top-24 select-none overflow-y-auto max-h-[56rem]">
                <PageSelectionButton
                    content={t("guides")}
                    target="guides"
                />
                <PageSelectionButton
                    content={t("manual")}
                    target="manual/introduction"
                />
                <PageSelectionButton
                    className="!indent-12"
                    content={t("manual-prerequisites")}
                    target="manual/prerequisites"
                />
                <PageSelectionButton
                    className="!indent-12"
                    content={t("manual-basics")}
                    target="manual/basics"
                />
                <PageSelectionButton
                    className="!indent-12"
                    content={t("manual-forest-management-planning")}
                    target="manual/forest-management-planning"
                />
                <PageSelectionButton
                    className="!indent-12"
                    content={t("manual-action-planning")}
                    target="manual/action-planning"
                />
                <PageSelectionButton
                    className="!indent-12"
                    content={t("manual-drone-operations")}
                    target="manual/drone-operations"
                />
                <PageSelectionButton
                    className="!indent-12"
                    content={t("manual-advanced")}
                    target="manual/advanced"
                />
                <PageSelectionButton
                    content={t("api")}
                    target="api"
                />
                <PageSelectionButton
                    content={t("faq")}
                    target="faq"
                />
            </div>
        </div>
    );
}
